import * as blockEngine from '@smartfire/js-block-engine';
import {setupWordpressSupport} from '@smartfire/js-block-engine/wordpress';


const isWordpressEditorPage = window && (<any>window).wp && (<any>window).wp.editor;
if (isWordpressEditorPage) {

    const promises: Promise<any>[] = [];
    const originalDomReady = (<any>window).wp.domReady;
    const domReadyWrap = (callback) => {
        Promise.all(promises).then(() => originalDomReady(callback));
    };

    (<any>window).wp = new Proxy((<any>window).wp, {
        get(target: any, p: string | symbol): any {
            if (p === 'domReady') {
                return domReadyWrap;
            } else {
                return target[p];
            }
        },
    });

    // Force block load
    blockEngine.addBlockRegistryListener('registration' as any as never, (e) => {
        promises.push(e.detail.loader());
    });

    try {

        let editorAssets = {styles: "", scripts: ""};
        let localEditorAssets = {styles: "", scripts: ""};

        Object.defineProperty(window, "__editorAssets", {
            get(): any {
                return {
                    styles: editorAssets.styles + "\n" + localEditorAssets.styles,
                    scripts: editorAssets.scripts + "\n" + localEditorAssets.scripts,
                }
            },
            set(v: any) {
                editorAssets = v
            }
        });

        let i = 1;
        const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach(n => {
                        if(n.nodeName.toLowerCase() === "link" && (<Element>n).attributes.getNamedItem("rel")?.value === "stylesheet") {
                            const link = n as HTMLLinkElement;
                            if(!link.getAttribute('id')) {
                                link.setAttribute("id", "stylesheet-" + i++)
                            }
                            let code = link.outerHTML;
                            localEditorAssets.styles += "\n" + code;
                        }
                    });
                }
            }
        });
        observer.observe(document.getElementsByTagName('head').item(0)!, {
            childList: true,
        });
    } catch (e) {
        console.error('Error while configuring the style listener, some wordpress features may not work\n', e);
    }

    // Add our categories to the editor
    setupWordpressSupport();
}


export default blockEngine;